import Vue from 'vue'

const eventbus = new Vue()

global.eventbus = eventbus // for cashregister ipc

export default eventbus
